import { Component, Input } from '@angular/core';
import { NzResultStatusType } from 'ng-zorro-antd/result';

@Component({
  selector: 'em-error-result',
  styleUrls: ['./error-result.component.less'],
  templateUrl: './error-result.component.html',
  standalone: false,
})
export class ErrorResultComponent {
  @Input() public title = 'SAP gave an error';
  @Input() public subTitle = '';
  @Input() public icon = 'meh-twotone';
  @Input() public status: NzResultStatusType = 'info';
}
